import TenantTheme from '../../components/settings/theme/TenantTheme'

const Theme = () => {
  return (
    <div className="space-y-10">
      <TenantTheme />
    </div>
  )
}

export default Theme
